import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$locale/_dashboard/docs")({
  component: DocsPage,
});

function DocsPage() {
  return (
    <div className="py-6">
      <h1 className="text-2xl font-semibold">Documentation</h1>
      <p className="text-muted-foreground mt-2">
        Learn how to use the Alkana API.
      </p>
    </div>
  );
}
